module.exports = __webpack_public_path__ + "static/media/alicorn.0d145062.svg";